module.exports = __webpack_public_path__ + "img/img (21).36b5af6c.png";